import { DEFAULT_KEY as INIT_SELECTED_APP_KEY } from '../../../websiteBridge/pages/Home/content';

export const initialState = {
	selectedAppKey: INIT_SELECTED_APP_KEY
};

export default {
	initialState
};
